import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgSwitchVertical = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 14 14"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.313}
      d="M9.333 9.916h-7m0 0 2.334 2.334M2.333 9.916l2.334-2.333M4.667 4.082h7m0 0L9.333 1.75m2.333 2.333L9.333 6.416"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSwitchVertical);
export default ForwardRef;
